<template>
  <div
    class="d-flex justify-content-center align-items-center box-dual-ring"
    v-if="initial_loading"
  >
    <div class="lds-dual-ring"></div>
  </div>
  <div class="container cont-ispirazioni py-3">
    <template v-if="header_ispirazioni">
      <div
        class="text-center text-uppercase pt-3 title"
        v-html="header_ispirazioni.val('titolo')"
      ></div>
      <div
        class="text-center text-uppercase py-2 sub-title"
        v-html="header_ispirazioni.val('sottotitolo')"
      ></div>
      <div>
        <p
          class="text-center par"
          v-html="header_ispirazioni.val('descrizione_introduttiva')"
        ></p>
      </div>
    </template>
    <!-- {{ this.filtri_prodotto.mood }} -->
    <div class="configuratore d-flex flex-column flex-lg-row py-5">
      <div class="col-lg-3 col-12">
        <div class="option-filter p-3">
          <!-- ricerca per codice o nome -->
          <div class="search-filter mb-3">
            <input
              v-model="steal_src"
              type="text"
              :placeholder="trans[schema.lang]['search']"
            />
          </div>

          <div
            v-b-toggle.collapse-1
            class="main-filter d-flex justify-content-between p-2"
          >
          {{ trans[schema.lang]['filter'] }}

            <img src="../public/icone/filter-option.png" alt="freccia" />
          </div>
          <b-collapse visible id="collapse-1" class="mt-2 container-collapse">
            <div v-for="filtro in filtri_prodotto" :key="filtro">
              <div v-if="filtro.options" class="py-2">
                <div
                  class="div-ider py-2 px-0 d-flex justify-content-between"
                  :class="filtro.collapse ? 'collapsed' : null"
                  aria-controls="collapse-4"
                  @click="filtro.collapse = !filtro.collapse"
                  v-if="filtro.options"
                >
                {{ trans[schema.lang][filtro.alias] }}
                  <img
                    src="../public/icone/freccia-espandi.png"
                    alt="freccia"
                    :class="filtro.collapse ? 'rotate-img-collapse' : null"
                    class="img-collapse"
                  />
                </div>
                <b-collapse
                  id="collapse-4"
                  v-model="filtro.collapse"
                  class="mt-2"
                >
                  <div
                    v-if="
                      filtro.alias == 'altezza' ||
                      filtro.alias == 'lunghezza_lato_1_superiore_esterno' ||
                      filtro.alias == 'capacit'
                    "
                  >
                    <div style="padding: 1em 0;">
                      <Slider
                        v-model="filtro.value"
                        :min="filtro.min"
                        :max="filtro.max"
                        range
                        class="w-14rem"
                        @slideend="refreshProdotti()"
                      />
                    </div>
                    <div class="input-slider">
                      <InputText
                        type="text"
                        v-model="filtro.value[0]"
                        @change="refreshProdotti()"
                        disabled="true"
                      />
                      <InputText
                        type="text"
                        v-model="filtro.value[1]"
                        @change="refreshProdotti()"
                        disabled="true"
                      />
                    </div>
                  </div>
                  <div
                    v-else
                    v-for="option in filtro.options"
                    :key="option"
                    class="section-filter py-2 d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      v-model="filtro.selected"
                      @change="refreshProdotti()"
                      :value="option"
                      :id="option"
                      class="me-2"
                    />
                    <img
                      v-if="
                        filtro.title == 'Forma' || filtro.title == 'Tipo parete'
                      "
                      class="mx-2"
                      :src="'/icone/' + getIcoName(option) + '.svg'"
                      width="25"
                      height="25"
                    />
                    <img
                      v-if="filtro.alias == 'colori' && option.url"
                      class="mx-2"
                      :src="option.url.link({ ext: 'webp' })"
                      width="25"
                      height="25"
                    />
                    <label for="checkbox">
                      <div v-if="filtro.alias == 'colori'">
                        {{ option.name }}
                      </div>
                      <div v-else>{{ option }}</div>
                    </label>
                  </div>
                </b-collapse>
              </div>
            </div>

            <!-- <label class="form-label div-ider mt-3" for="altezza"
              >Altezza</label
            >
            <div class="range">
              <input
                type="range"
                class="multi-range-field form-range"
                id="altezza"
              />
            </div>
            <label class="form-label div-ider mt-3" for="lung-sup-est"
              >Lunghezza superiore esterna</label
            >
            <div class="range">
              <input
                type="range"
                class="multi-range-field form-range"
                id="lung-sup-est"
              />
            </div>
            <label class="form-label div-ider mt-3" for="capacita"
              >Capacità</label
            >
            <div class="range">
              <input
                type="range"
                class="multi-range-field form-range"
                id="capacita"
              />
            </div> -->
          </b-collapse>
        </div>
      </div>
      <!-- sezione prodotti -->
      <div class="col-lg-9 col-12 px-0 px-lg-2 py-5 py-lg-0 flex-wrap">
        <div
          class="col-12 d-flex align-items-start flex-wrap"
          v-if="!is_loading"
        >
        <div v-if="products_filtered.length==0" style="width: 100%; display: flex; justify-content:center">Nessuna corrispondenza</div>
          <div
          v-else
            class="card-prod px-2 pb-4 d-flex flex-column align-items-center"
            v-for="prod in products_filtered"
            :key="prod.id"
          >
            <div
              class="anchor-card"
              style="cursor:pointer"
              @click="goToPage('product/'+ clearParams(prod.val('nome')))"
            >
              <div class="card-image">
                <img
                  class="img-fluid"
                  v-if="prod.val('image')"
                  :src="
                    prod.val('image').link({ x: '200', y: '200', ext: 'webp' })
                  "
                  :alt="prod.val('nome')"
                />
                <img
                  class="img-fluid"
                  v-else
                  src="/collezioni/placeholder.png"
                  width="200"
                  height="200"
                  alt="placeholder"
                />
              </div>
              <div class="mt-2 text-center text-uppercase">
                {{ prod.val("nome") }}
              </div>
              <div class="mt-2 text-center desc-estesa-card">
                {{ prod.val("descrizione_estesa") }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="d-flex justify-content-center align-items-center box-dual-ring"
        >
          <div class="lds-dual-ring"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import { Schema } from "onpage-js";
import { uniq } from "lodash";
import { uniqBy, orderBy, min, max } from "lodash";
import Slider from "primevue/slider";
import InputText from "primevue/inputtext";




export default defineComponent({
  components: {
    Slider,
    InputText,
  },
  props: {
    schema: {
      type: Schema,
      required: true,
    },
    // pagine_web: {
    //   required: true,
    // },
  },
  mounted() {
    window.document.getElementById('app').scrollIntoView()
  },
  data() {
    return {
      pagina_web_ispirazioni: null,
      header_ispirazioni: null,
      all_product: null,
      products_filtered: null,
      is_loading: false,
      initial_loading: false,
      steal_src: "",
      pagine_web: null,
      filtri_prodotto: {
        mood: {
          options: null,
          selected: [],
          title: "Stile/Mood",
          alias: "mood",
          collapse: true,
        },
        forma: {
          options: null,
          selected: [],
          title: "Forma",
          alias: "forma",
          collapse: true,
        },
        illuminabile: {
          options: ["Si", "No"],
          selected: [],
          title: "Illuminabile",
          alias: "illuminabile",
          collapse: true,
        },
        tipo_parete: {
          options: null,
          selected: [],
          title: "Tipo parete",
          alias: "tipo_parete",
          collapse: true,
        },
        altezza: {
          options: null,
          selected: [],
          title: "Altezza (cm)",
          alias: "altezza",
          collapse: true,
          value: [],
          min: null,
          max: null,
        },
        lunghezza_lato_1_superiore_esterno: {
          options: null,
          selected: [],
          title: "Larghezza (cm)",
          alias: "lunghezza_lato_1_superiore_esterno",
          collapse: true,
          value: [],
          min: null,
          max: null,
        },
        capacit: {
          options: null,
          selected: [],
          title: "Capacità (l)",
          alias: "capacit",
          collapse: true,
          value: [],
          min: null,
          max: null,
        },
        colori: {
          options: null,
          selected: [],
          title: "Disponibilità colore",
          alias: "colori",
          collapse: true,
        },
      },
      trans: {
        'it': {
          search: "Cerca prodotto",
          filter: "Filtri",
          mood: "Stile/Mood",
          forma: "Forma",
          illuminabile: "Illuminabile",
          tipo_parete: "Tipo parete",
          altezza: "Altezza (cm)",
          lunghezza_lato_1_superiore_esterno: "Larghezza (cm)",
          capacit: "Capacità (l)",
          colori: "Disponibilità colore",
        },
        'en': {
          search: "Search your product",
          filter: "Filters",
          mood: "Style/Mood",
          forma: "Shape",
          illuminabile: "Illuminable",
          tipo_parete: "Wall type",
          altezza: "Height (cm)",
          lunghezza_lato_1_superiore_esterno: "Width (cm)",
          capacit: "Capacity (l)",
          colori: "Colour availability",
        }
      },
      trans_ico: {
        "Round": "Rotondo",
        "Square": "Quadrato",
        "Corner": "Angolare",
        "Oval": "Ovale",
        "Rectangular": "Rettangolare",
        "Semicircle": "Mezzaluna",
        "Single wall": "Singola",
        "Double wall": "Doppia (vasca interna)",
      }
    };
  },
  async created() {
    this.moodControl();
    this.initial_loading = true;
    this.initialize().then(() => {

      if (this.$route.query.q) {
      this.steal_src = this.$route.query.q;
      }
      if (this.$route.query.m) {
        this.filtri_prodotto["mood"].selected.push(this.$route.query.m);
      }

      this.refreshProdotti().then(() =>{
        this.initial_loading = false;
      })
    });
  },
  computed: {},
  methods: {
    goToPage(path) {
      console.log(path)
      this.$router.push({ path: `/${path.replace('#/', '')}` })
    },
    getIcoName(option){
      if(this.schema.lang=='en'){
        return this.trans_ico[option]
      }
      return option
    },
    async initialize(){
      this.is_loading = true;

      let query_prod = this.schema
        .query("prodotti")
        .with("modelli.articoli.colori")
        .with("mood")
        .with("sezioni.collezioni");

      this.all_product = await query_prod.all();
      this.products_filtered = this.all_product;

      this.popolamento_filtri("initial");


      let pagineWeb_query = this.schema
        .query("pagine_web")
        .with("header")
        .with("sezioni.box_capitoli")
        .with("documentazione.tipologia_documento");


      this.pagine_web = await pagineWeb_query.all();

    },
    async refreshProdotti() {
      this.is_loading = true;

      let query_prod = this.schema
        .query("prodotti")
        .with("modelli.articoli.colori")
        .with("mood")
        .with("sezioni.collezioni");
      this.all_product = await query_prod.all();
      
      console.log(this.all_product.map(x => x.id))
      this.products_filtered = this.all_product;

      // filtraggio prodotti
      this.products_filtered = this.filtraggio_prodotti();
      // popolamento filtri
      this.popolamento_filtri();

      this.is_loading = false;
    },
    popolamento_filtri(initial = null) {
      for (const filtro in this.filtri_prodotto) {
        let prods_without_current_filter
        if(!initial){
          prods_without_current_filter = this.filtraggio_prodotti(filtro);
        }else{
          prods_without_current_filter = this.all_product;
        }
        let stuff = [];

        let cases = [];

        switch (filtro) {
          case "illuminabile":
            prods_without_current_filter.filter(
              (prod) => prod.val("illuminabile") == true
            ).length > 0
              ? stuff.push("Si")
              : "";
            prods_without_current_filter.filter(
              (prod) => prod.val("illuminabile") != true
            ).length > 0
              ? stuff.push("No")
              : "";
            break;
          case "colori":
            prods_without_current_filter.forEach((prod) => {
              prod.relSync("modelli").forEach((mod) => {
                mod.relSync("articoli").forEach((art) => {
                  let art_colori = art.relSync("colori");
                  if (art_colori.length > 0) {
                    stuff.push(
                      art_colori.map((x) => ({
                        ["name"]: x.val("nome"),
                        ["url"]: x.val("image"),
                      }))[0]
                    );
                  }
                });
              });
            });
            break;
          case "altezza":
          case "lunghezza_lato_1_superiore_esterno":
          case "capacit":
            prods_without_current_filter.forEach((prod) => {
              prod.relSync("modelli").forEach((mod) => {
                if (mod.val(filtro)) {
                  cases.push(...mod.values(filtro));
                }
              });
            });
            prods_without_current_filter.forEach((prod) => {
              prod.relSync("modelli").forEach((mod) => {
                let confronto =
                  parseFloat(min(cases)) <= parseFloat(mod.val(filtro)) &&
                  parseFloat(max(cases)) >= parseFloat(mod.val(filtro));

                if (confronto && mod.val(filtro)) {
                  stuff.push(...mod.values(filtro));
                }
              });
            });
            if (!this.filtri_prodotto[filtro].min) {
              this.filtri_prodotto[filtro].max = max(stuff);
              this.filtri_prodotto[filtro].min = min(stuff);
              this.filtri_prodotto[filtro].value[0] = min(stuff);
              this.filtri_prodotto[filtro].value[1] = max(stuff);
            }
            break;
          case "mood":
            prods_without_current_filter.forEach((prod) => {
              let mood_articoli = prod.relSync("mood");
              mood_articoli = mood_articoli.map((x) => x.val("nome"));
              if (mood_articoli.length > 0) {
                stuff = stuff.concat(mood_articoli);
              }
            });
            break;
          default:
            prods_without_current_filter.forEach((prod) => {
              stuff.push(...prod.values(filtro));
            });
            break;
        }

        if (filtro == "colori") {
          stuff = uniqBy(stuff, "name");
          stuff = orderBy(stuff, "name");
        } else {
          stuff = uniq(stuff);
        }
        this.filtri_prodotto[filtro].options = stuff;
      }
    },
    filtraggio_prodotti(filtro_da_escludere = null) {
      // param filtro_da_escludere = campo da escludere nel filtraggio dei prodotti

      let prods = this.all_product;
      for (const filtro in this.filtri_prodotto) {
        if (
          filtro_da_escludere == null ||
          (filtro_da_escludere && filtro_da_escludere != filtro)
        ) {
          // se il filtro corrente ha almeno una opzione selezionata oppure hanno una value impostata per gli slider allora vengono filtrati i prodotti per quel filtro
          if (
            (this.filtri_prodotto[filtro].selected &&
              this.filtri_prodotto[filtro].selected.length > 0) ||
            (this.filtri_prodotto[filtro].value &&
              this.filtri_prodotto[filtro].value.length > 0)
          ) {
            switch (filtro) {
              case "illuminabile":
                if (this.filtri_prodotto[filtro].selected == "Si") {
                  prods = prods.filter(
                    (prod) => prod.val("illuminabile") == true
                  );
                } else if (this.filtri_prodotto[filtro].selected == "No") {
                  prods = prods.filter(
                    (prod) => prod.val("illuminabile") != true
                  );
                }
                break;
              case "colori":
                prods = prods.filter((prod) => {
                  return prod.relSync("modelli.articoli.colori").find((c) =>
                    this.filtri_prodotto[filtro].selected.some((x) => {
                      return x.name == c.val("nome");
                    })
                  );
                });
                break;
              case "altezza":
              case "lunghezza_lato_1_superiore_esterno":
              case "capacit":
                prods = prods.filter((prod) => {
                  return prod.relSync("modelli").find((mod) => {
                    if (!mod.val(filtro)) return true;
                    let confronto =
                      parseFloat(min(this.filtri_prodotto[filtro].value)) <=
                        parseFloat(mod.val(filtro)) &&
                      parseFloat(max(this.filtri_prodotto[filtro].value)) >=
                        parseFloat(mod.val(filtro));
                    return confronto;
                  });
                });
                break;

              case "mood":
                prods = prods.filter((prod) => {
                  return prod
                    .relSync("mood")
                    .some((m) =>
                      this.filtri_prodotto[filtro].selected.includes(
                        m.val("nome")
                      )
                    );
                });
                break;

              default:
                prods = prods.filter((prod) =>
                  this.filtri_prodotto[filtro].selected.some((x) =>
                    prod.values(this.filtri_prodotto[filtro].alias).includes(x)
                  )
                );
                break;
            }
          }
        }
      }
      prods.forEach((p) => {
        if (p.relSync("sezioni").length > 0) {
          p.collezione = p.val("sezioni.collezioni.nome");
        }
      });


      // filtraggio per ricerca
      if(this.steal_src && this.steal_src != ""){
        prods = prods.filter((prod)=>{

          if(prod.val("nome").toLowerCase().includes(this.steal_src.toLowerCase())){
            return true
          }
          if(prod.val("descrizione_estesa").toLowerCase().includes(this.steal_src.toLowerCase())){
            return true
          }
          return prod.relSync("modelli").find((mod) => {
            if (mod.val('nome').toLowerCase().includes(this.steal_src.toLowerCase())) return true;
            return mod.relSync("articoli").find((art) => {
              if (art.val('codice_esploso').toLowerCase().includes(this.steal_src.toLowerCase())) return true;
            })
          });

        })
      }

      return prods;
    },
    getPreviewProdotti() {
      this.pagina_web_ispirazioni = this.pagine_web.filter(
        (x) => x.val("nome") == "Prodotti"
      );
      console.log(this.pagine_web[0])
      if (this.pagina_web_ispirazioni.length > 0) {
        this.header_ispirazioni =
          this.pagina_web_ispirazioni[0].relSync("header")[0];
      }
    },
    clearParams(nome) {
      return nome.replaceAll("/", "-").replaceAll(" ", "_");
    },
    moodControl() {
      if (this.$route.params.ispirazioni) {
        this.filtri_prodotto.mood.selected.push(this.$route.params.ispirazioni);
        this.refreshProdotti();
      }
    },
  },
  watch: {
    steal_src() {
      this.refreshProdotti();
    },
    pagine_web() {
      this.getPreviewProdotti();
    },
    '$route.query.q'(){
      this.steal_src = this.$route.query.q;
      this.refreshProdotti()
    }
  },
});
</script>

<style scoped>
.cont-ispirazioni {
  min-height: 100vh;
  justify-content: flex-start !important;
}
.container-collapse input {
  background-color: #fff;
}
.container-collapse input:hover {
  cursor: pointer;
}
.container-collapse input:checked {
  background-color: #747474;
}
.section-filter {
  padding: 0 10px;
  transition: all 0.3s;
}
.section-filter:hover {
  background-color: #dedddd;
}
.search-filter input {
  padding: 8px 10px;
  border: 1px solid #d0d0d0;
  font-weight: 400;
  color: #646363;
}
.img-collapse {
  transition: all 200ms ease-in-out;
}
.rotate-img-collapse {
  transform: rotate(180deg);
}
.desc-estesa-card {
  font-weight: 100;
}
.main-filter {
  border: none !important;
  border-radius: none !important;
  background-color: transparent !important;
  color: #000 !important;
}
.main-filter {
  cursor: pointer;
}
.main-filter:hover {
  background-color: #b7b7b7 !important;
}
.card-prod {
  width: calc(100% / 4);
}

.anchor-card {
  transition: all 200ms ease-in;
  text-decoration: none;
  color: #646363;
}

.anchor-card:hover {
  transform: scale(1.1);
}

.option-filter {
  background-color: #f1f3f3;
}

.option-filter input[type="text"] {
  width: 100%;
}

.div-ider {
  border-bottom: 1px solid #d9d9d9;
  font-weight: 600;
  cursor: pointer;
  color: #646363;
}

.form-range::-moz-range-thumb {
  background-color: #646363;
}

.form-label {
  width: 100%;
}

.title {
  font-size: 32px;
}

.sub-title {
  font-size: 24px;
}

.sub-title,
.par {
  color: #646363;
}

.input-slider {
  display: flex;
  justify-content: space-between;
  padding: 1em 0;
  gap: 3px;
}

@media (max-width: 1024px) {
  .div-ider {
    width: 100%;
    text-align: left;
  }
}

@media (max-width: 768px) {
  .card-prod {
    width: calc(100% / 2);
  }
}
</style>

<style>
/* LOADER */
.box-dual-ring {
  height: 100vh;
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #646363;
  border-color: #646363 transparent #646363 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.p-slider .p-slider-range {
    background: #616161;
}
.p-slider .p-slider-handle {
    border: 2px solid #616161;
}
</style>
